(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["shipping-estimate"] && !Shopify.designMode) return;
  try {
    (function () {
  document.addEventListener('DOMContentLoaded', initShippingEstimate);
  if (document.readyState !== 'loading') initShippingEstimate();

  function initShippingEstimate() {
    document.querySelectorAll('.instock-24h-day').forEach(function (el) {
      if (el.dataset.init) return;
      el.dataset.init = '1';

      var timeZone = el.dataset.timezone || 'Europe/Paris';
      var cutoffHour = parseInt(el.dataset.cutoffHour, 10);
      if (isNaN(cutoffHour)) cutoffHour = 12;

      // "1,2,3,4,5" -> [1,2,3,4,5] (1=lundi ... 7=dimanche)
      var workingDays = (el.dataset.workingDays || '1,2,3,4,5')
        .split(',')
        .map(function (d) { return parseInt(d.trim(), 10); })
        .filter(function (d) { return !isNaN(d); });

      var now = new Date();

      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: timeZone,
        weekday: 'short',
        hour: 'numeric',
        hour12: false
      }).formatToParts(now);

      var weekdayShort = parts.find(function (p) { return p.type === 'weekday'; }).value;
      var hour = parseInt(parts.find(function (p) { return p.type === 'hour'; }).value, 10);

      // ISO : 1=lundi ... 7=dimanche
      var isoMap = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 };
      var todayIso = isoMap[weekdayShort];

      var labels = {
        1: 'lundi', 2: 'mardi', 3: 'mercredi', 4: 'jeudi',
        5: 'vendredi', 6: 'samedi', 7: 'dimanche'
      };

      // Si on est avant l'heure de coupure ET aujourd'hui est un jour ouvré,
      // l'expédition peut partir aujourd'hui -> on affiche le prochain jour
      // ouvré à PARTIR de demain quand même (le message dit "colis part demain").
      // On cherche le prochain jour ouvré strictement après aujourd'hui.
      function nextWorkingDayLabel(fromIso) {
        var next = fromIso;
        for (var i = 0; i < 7; i++) {
          next = next === 7 ? 1 : next + 1;
          if (workingDays.indexOf(next) !== -1) {
            var isTomorrow = (next === (fromIso === 7 ? 1 : fromIso + 1));
            return isTomorrow ? 'demain' : labels[next];
          }
        }
        return 'demain';
      }

      el.textContent = nextWorkingDayLabel(todayIso);
    });
  }

  window.initShippingEstimate = initShippingEstimate;
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ugc-carousel"] && !Shopify.designMode) return;
  try {
    (function () {
  document.addEventListener('DOMContentLoaded', initUGC);
  if (document.readyState !== 'loading') initUGC();

  function initUGC() {
    document.querySelectorAll('.ugc-block').forEach(function (block) {
      if (block.dataset.ugcInit) return;
      block.dataset.ugcInit = '1';

      var track   = block.querySelector('.ugc-block__track');
      var outer   = block.querySelector('.ugc-block__outer');
      var slides  = Array.from(track.querySelectorAll('.ugc-block__slide'));
      var btnPrev = block.querySelector('.ugc-block__btn--prev');
      var btnNext = block.querySelector('.ugc-block__btn--next');

      var lightbox = block.nextElementSibling;
      var lbImg    = lightbox.querySelector('.ugc-lightbox__img');
      var lbVid    = lightbox.querySelector('.ugc-lightbox__vid');
      var lbClose  = lightbox.querySelector('.ugc-lightbox__close');
      var lbPrev   = lightbox.querySelector('.ugc-lightbox__prev');
      var lbNext   = lightbox.querySelector('.ugc-lightbox__next');
      var lbBack   = lightbox.querySelector('.ugc-lightbox__backdrop');

      var carIdx  = 0;
      var lbIdx   = 0;
      var isDragging = false;
      var dragStartX = 0;
      var dragScrollStart = 0;
      var dragMoved = false;
      var DRAG_THRESHOLD = 5;

      /* ---- helpers ---- */
      function slideW()  { return slides[0] ? slides[0].offsetWidth : 80; }
      function gapPx()   { return parseInt(getComputedStyle(track).gap) || 8; }
      function perView() {
        return Math.round((outer.offsetWidth + gapPx()) / (slideW() + gapPx()));
      }
      function maxIdx()  { return Math.max(0, slides.length - perView()); }

      /* ---- carousel arrows ---- */
      function renderCarousel(animated) {
        if (animated === false) {
          track.style.transition = 'none';
        } else {
          track.style.transition = 'transform 0.32s cubic-bezier(0.4, 0, 0.2, 1)';
        }
        track.style.transform = 'translate3d(-' + (carIdx * (slideW() + gapPx())) + 'px,0,0)';
        var atStart = carIdx === 0, atEnd = carIdx >= maxIdx();
        if (btnPrev) { btnPrev.disabled = atStart; btnPrev.classList.toggle('disabled', atStart); }
        if (btnNext) { btnNext.disabled = atEnd;   btnNext.classList.toggle('disabled', atEnd); }
      }

      if (btnPrev) btnPrev.addEventListener('click', function () {
        if (carIdx > 0) { carIdx--; renderCarousel(); }
      });
      if (btnNext) btnNext.addEventListener('click', function () {
        if (carIdx < maxIdx()) { carIdx++; renderCarousel(); }
      });

      window.addEventListener('resize', function () { renderCarousel(); });
      renderCarousel();

      /* ---- drag to scroll (desktop) ---- */
      outer.style.cursor = 'grab';

      outer.addEventListener('mousedown', function (e) {
        isDragging = true;
        dragMoved  = false;
        dragStartX = e.clientX;
        dragScrollStart = carIdx * (slideW() + gapPx());
        outer.style.cursor = 'grabbing';
        track.style.transition = 'none';
        e.preventDefault();
      });

      window.addEventListener('mousemove', function (e) {
        if (!isDragging) return;
        var diff = dragStartX - e.clientX;
        if (Math.abs(diff) > DRAG_THRESHOLD) dragMoved = true;
        if (!dragMoved) return;
        var newX = Math.max(0, dragScrollStart + diff);
        track.style.transform = 'translate3d(-' + newX + 'px,0,0)';
      });

      window.addEventListener('mouseup', function (e) {
        if (!isDragging) return;
        isDragging = false;
        outer.style.cursor = 'grab';

        if (dragMoved) {
          var diff = dragStartX - e.clientX;
          var step = slideW() + gapPx();
          var rawIdx = carIdx + diff / step;
          carIdx = Math.round(rawIdx);
          carIdx = Math.max(0, Math.min(carIdx, maxIdx()));
          renderCarousel();
        }
      });

      window.addEventListener('mouseleave', function () {
        if (isDragging) {
          isDragging = false;
          outer.style.cursor = 'grab';
          renderCarousel();
        }
      });

      /* ---- touch swipe (mobile) ---- */
      var touchStartX  = 0;
      var touchScrollStart = 0;

      outer.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
        touchScrollStart = carIdx * (slideW() + gapPx());
        track.style.transition = 'none';
      }, { passive: true });

      outer.addEventListener('touchmove', function (e) {
        var diff = touchStartX - e.touches[0].clientX;
        var newX = Math.max(0, touchScrollStart + diff);
        track.style.transform = 'translate3d(-' + newX + 'px,0,0)';
      }, { passive: true });

      outer.addEventListener('touchend', function (e) {
        var diff = touchStartX - e.changedTouches[0].clientX;
        var step = slideW() + gapPx();
        if (Math.abs(diff) > step * 0.2) {
          var delta = Math.round(diff / step);
          carIdx = Math.max(0, Math.min(carIdx + delta, maxIdx()));
        }
        renderCarousel();
      }, { passive: true });

      /* ---- clic sur slide → lightbox ---- */
      slides.forEach(function (slide) {
        slide.querySelector('.ugc-block__trigger').addEventListener('click', function (e) {
          if (dragMoved) { e.stopPropagation(); e.preventDefault(); return; }
          var idx = parseInt(slide.dataset.index);
          openLb(idx);
        });
      });

      /* ---- lightbox ---- */
      function mediaOf(slide) {
        var img = slide.querySelector('img');
        var vid = slide.querySelector('video');
        return { type: vid ? 'video' : 'image', src: vid ? vid.src : (img ? img.src : '') };
      }

      function openLb(idx) {
        lbIdx = idx;
        renderLb();
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }

      function closeLb() {
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        lbVid.pause(); lbVid.src = ''; lbVid.classList.remove('active');
        lbImg.src = ''; lbImg.classList.remove('active');
      }

      function renderLb() {
        var m = mediaOf(slides[lbIdx]);
        lbImg.classList.remove('active'); lbVid.classList.remove('active');
        if (m.type === 'video') {
          lbVid.src = m.src; lbVid.classList.add('active'); lbVid.play();
        } else {
          lbImg.src = m.src; lbImg.classList.add('active');
        }
      }

      lbClose.addEventListener('click', closeLb);
      lbBack.addEventListener('click', closeLb);
      lbPrev.addEventListener('click', function () { lbIdx = (lbIdx - 1 + slides.length) % slides.length; renderLb(); });
      lbNext.addEventListener('click', function () { lbIdx = (lbIdx + 1) % slides.length; renderLb(); });

      /* swipe lightbox */
      var lbTouchX = 0;
      lightbox.addEventListener('touchstart', function (e) { lbTouchX = e.touches[0].clientX; }, { passive: true });
      lightbox.addEventListener('touchend', function (e) {
        var d = lbTouchX - e.changedTouches[0].clientX;
        if (Math.abs(d) > 40) d > 0
          ? (lbIdx = (lbIdx+1)%slides.length, renderLb())
          : (lbIdx = (lbIdx-1+slides.length)%slides.length, renderLb());
      });

      /* keyboard */
      document.addEventListener('keydown', function (e) {
        if (lightbox.getAttribute('aria-hidden') === 'true') return;
        if (e.key === 'Escape')      closeLb();
        if (e.key === 'ArrowLeft')   { lbIdx = (lbIdx-1+slides.length)%slides.length; renderLb(); }
        if (e.key === 'ArrowRight')  { lbIdx = (lbIdx+1)%slides.length; renderLb(); }
      });
    });
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ugc-reel-carousel"] && !Shopify.designMode) return;
  try {
    (function () {
  document.addEventListener('DOMContentLoaded', initReels);
  if (document.readyState !== 'loading') initReels();

  function initReels() {
    document.querySelectorAll('.ugc-reel').forEach(function (block) {
      if (block.dataset.reelInit) return;
      block.dataset.reelInit = '1';

      var track   = block.querySelector('.ugc-reel__track');
      var outer   = block.querySelector('.ugc-reel__outer');
      var slides  = Array.from(track.querySelectorAll('.ugc-reel__slide'));
      var btnPrev = block.querySelector('.ugc-reel__btn--prev');
      var btnNext = block.querySelector('.ugc-reel__btn--next');

      var lightbox    = block.nextElementSibling;
      var lbVid       = lightbox.querySelector('.ugc-reel-lightbox__vid');
      var lbClose     = lightbox.querySelector('.ugc-reel-lightbox__close');
      var lbPrev      = lightbox.querySelector('.ugc-reel-lightbox__prev');
      var lbNext      = lightbox.querySelector('.ugc-reel-lightbox__next');
      var lbBack      = lightbox.querySelector('.ugc-reel-lightbox__backdrop');
      var btnPlay     = lightbox.querySelector('.ugc-reel-lb-playpause');
      var btnMute     = lightbox.querySelector('.ugc-reel-lb-mute');
      var iconPause   = btnPlay.querySelector('.icon-pause');
      var iconPlay    = btnPlay.querySelector('.icon-play');
      var iconUnmuted = btnMute.querySelector('.icon-unmuted');
      var iconMuted   = btnMute.querySelector('.icon-muted');

      var carIdx = 0, lbIdx = 0;
      var isDragging = false, dragStartX = 0, dragScrollStart = 0, dragMoved = false;
      var DRAG_THRESHOLD = 5;

      /* ---- helpers ---- */
      function slideW()  { return slides[0] ? slides[0].offsetWidth : 80; }
      function gapPx()   { return parseInt(getComputedStyle(track).gap) || 8; }
      function perView() { return Math.round((outer.offsetWidth + gapPx()) / (slideW() + gapPx())); }
      function maxIdx()  { return Math.max(0, slides.length - perView()); }

      /* ---- carousel ---- */
      function renderCarousel(animated) {
        track.style.transition = (animated === false)
          ? 'none'
          : 'transform 0.32s cubic-bezier(0.4, 0, 0.2, 1)';
        track.style.transform = 'translate3d(-' + (carIdx * (slideW() + gapPx())) + 'px,0,0)';
        var atStart = carIdx === 0, atEnd = carIdx >= maxIdx();
        if (btnPrev) { btnPrev.disabled = atStart; btnPrev.classList.toggle('disabled', atStart); }
        if (btnNext) { btnNext.disabled = atEnd;   btnNext.classList.toggle('disabled', atEnd); }
      }

      if (btnPrev) btnPrev.addEventListener('click', function () { if (carIdx > 0) { carIdx--; renderCarousel(); } });
      if (btnNext) btnNext.addEventListener('click', function () { if (carIdx < maxIdx()) { carIdx++; renderCarousel(); } });
      window.addEventListener('resize', function () { renderCarousel(); });
      renderCarousel();

      /* ---- drag desktop ---- */
      outer.style.cursor = 'grab';

      outer.addEventListener('mousedown', function (e) {
        isDragging = true; dragMoved = false;
        dragStartX = e.clientX;
        dragScrollStart = carIdx * (slideW() + gapPx());
        outer.style.cursor = 'grabbing';
        track.style.transition = 'none';
        e.preventDefault();
      });

      window.addEventListener('mousemove', function (e) {
        if (!isDragging) return;
        var diff = dragStartX - e.clientX;
        if (Math.abs(diff) > DRAG_THRESHOLD) dragMoved = true;
        if (!dragMoved) return;
        track.style.transform = 'translate3d(-' + Math.max(0, dragScrollStart + diff) + 'px,0,0)';
      });

      window.addEventListener('mouseup', function (e) {
        if (!isDragging) return;
        isDragging = false;
        outer.style.cursor = 'grab';
        if (dragMoved) {
          var diff = dragStartX - e.clientX;
          carIdx = Math.max(0, Math.min(Math.round(carIdx + diff / (slideW() + gapPx())), maxIdx()));
          renderCarousel();
        }
      });

      window.addEventListener('mouseleave', function () {
        if (isDragging) { isDragging = false; outer.style.cursor = 'grab'; renderCarousel(); }
      });

      /* ---- touch swipe ---- */
      var touchStartX = 0, touchScrollStart = 0;

      outer.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
        touchScrollStart = carIdx * (slideW() + gapPx());
        track.style.transition = 'none';
      }, { passive: true });

      outer.addEventListener('touchmove', function (e) {
        var diff = touchStartX - e.touches[0].clientX;
        track.style.transform = 'translate3d(-' + Math.max(0, touchScrollStart + diff) + 'px,0,0)';
      }, { passive: true });

      outer.addEventListener('touchend', function (e) {
        var diff = touchStartX - e.changedTouches[0].clientX;
        var step = slideW() + gapPx();
        if (Math.abs(diff) > step * 0.2) {
          carIdx = Math.max(0, Math.min(carIdx + Math.round(diff / step), maxIdx()));
        }
        renderCarousel();
      }, { passive: true });

      /* ---- clic → lightbox ---- */
      slides.forEach(function (slide) {
        slide.querySelector('.ugc-reel__trigger').addEventListener('click', function (e) {
          if (dragMoved) { e.stopPropagation(); e.preventDefault(); return; }
          openLb(parseInt(slide.dataset.index));
        });
      });

      /* ---- lightbox ---- */
      function srcOf(slide) { return slide.dataset.src || ''; }

      function openLb(idx) {
        lbIdx = idx;
        renderLb();
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }

      function closeLb() {
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        lbVid.pause();
        lbVid.src = '';
      }

      function renderLb() {
        lbVid.src = srcOf(slides[lbIdx]);
        lbVid.muted = false;
        lbVid.play().catch(function () {
          lbVid.muted = true;
          lbVid.play();
        });
        syncMuteIcon();
        syncPlayIcon();
      }

      function syncMuteIcon() {
        iconUnmuted.style.display = lbVid.muted ? 'none' : '';
        iconMuted.style.display   = lbVid.muted ? '' : 'none';
      }

      function syncPlayIcon() {
        iconPause.style.display = lbVid.paused ? 'none' : '';
        iconPlay.style.display  = lbVid.paused ? '' : 'none';
      }

      btnPlay.addEventListener('click', function () {
        lbVid.paused ? lbVid.play() : lbVid.pause();
        syncPlayIcon();
      });

      lbVid.addEventListener('play', syncPlayIcon);
      lbVid.addEventListener('pause', syncPlayIcon);

      btnMute.addEventListener('click', function () {
        lbVid.muted = !lbVid.muted;
        syncMuteIcon();
      });

      lbClose.addEventListener('click', closeLb);
      lbBack.addEventListener('click', closeLb);

      lbPrev.addEventListener('click', function () { lbIdx = (lbIdx - 1 + slides.length) % slides.length; renderLb(); });
      lbNext.addEventListener('click', function () { lbIdx = (lbIdx + 1) % slides.length; renderLb(); });

      /* swipe lightbox */
      var lbTouchX = 0;
      lightbox.addEventListener('touchstart', function (e) { lbTouchX = e.touches[0].clientX; }, { passive: true });
      lightbox.addEventListener('touchend', function (e) {
        var d = lbTouchX - e.changedTouches[0].clientX;
        if (Math.abs(d) > 40) {
          lbIdx = d > 0 ? (lbIdx + 1) % slides.length : (lbIdx - 1 + slides.length) % slides.length;
          renderLb();
        }
      });

      /* keyboard */
      document.addEventListener('keydown', function (e) {
        if (lightbox.getAttribute('aria-hidden') === 'true') return;
        if (e.key === 'Escape')     closeLb();
        if (e.key === 'ArrowLeft')  { lbIdx = (lbIdx - 1 + slides.length) % slides.length; renderLb(); }
        if (e.key === 'ArrowRight') { lbIdx = (lbIdx + 1) % slides.length; renderLb(); }
        if (e.key === ' ')          { e.preventDefault(); btnPlay.click(); }
      });
    });
  }

    window.initReels = initReels;
})();
  } catch(e) { console.error(e); }
})();

})();
